<div id="auth-container" [style.background]="'url(../../../assets/organisation/images/background.png)'">
  <div id="auth-outlet">
    <router-outlet />
  </div>
</div>
